import axiosInstance from "../utils/axios";

const BASE_URL = "/projects/v1";

async function getBasketById(id: string) {
  return axiosInstance.get(`${BASE_URL}/baskets/${id}`, {})
}

async function getProjectByCodeApi(code: string){
  return axiosInstance.get(`projects/v1/${code}`)
}

export {
  getBasketById,
  getProjectByCodeApi,
}